import { RequestMethod } from '../models/request-method.enum';

export const errorHandlingExceptions: Record<RequestMethod, RegExp[]> = {
  [RequestMethod.PATCH]: [new RegExp(/\/business-partners\/\d+$/)],
  [RequestMethod.GET]: [],
  [RequestMethod.POST]: [],
  [RequestMethod.DELETE]: [],
};
